export const useNonComplianceGroupInterpolationsFetcher = skip => {
  if (skip) return []

  return [
    {
      name: 'Local da não conformidade',
      id: '{{non_compliance.place.name}}',
      type: 'string',
      group: 'Não conformidade'
    },
    {
      name: 'Pergunta',
      id: '{{non_compliance.question.name}}',
      type: 'string',
      group: 'Não conformidade'
    }
  ]
}

export const useNonComplianceGroupRawInterpolationsFetcher = skip => {
  if (skip) return []

  return [
    {
      name: 'Local da não conformidade atualizada',
      id: '::{{non_compliance.place_id}}',
      type: 'raw_place'
    }
  ]
}
